import React, { useState } from "react";
import Assistant from "./Assistant";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

function Layout({ children }) {
  // Sur téléphone, le menu est un tiroir ouvert par le bouton ☰ de la barre du
  // haut (layout.css, max-width 900px). Chaque page monte son propre Layout :
  // changer de page referme donc le tiroir.
  const [menuOuvert, setMenuOuvert] = useState(false);
  const fermer = () => setMenuOuvert(false);
  return (
    <>
      <Navbar menuOuvert={menuOuvert} onMenu={() => setMenuOuvert((o) => !o)} />
      <div className="container">
        <Sidebar ouverte={menuOuvert} onFermer={fermer} />
        {menuOuvert && <div className="sidebar-voile" onClick={fermer} aria-hidden="true" />}
        <main className="content">
          {children}
        </main>
      </div>
      {/* Dans le Layout : l'assistant suit l'utilisateur sur tous les écrans
          plutôt que d'être une page qu'il faut quitter pour poser sa question. */}
      <Assistant />
    </>
  );
}

export default Layout;
